<template>
  <div>
    <div class="intro-y flex flex-row items-center sm:mt-8">
      <h2 class="text-lg font-medium mr-auto mt-3">
        เอกสาร{{ tableTab.label }}
      </h2>
      <div class="flex mt-4 sm:mt-0">
        <router-link
          class="btn btn-primary shadow-md mr-2"
          :to="{ name: 'memoMyActivitiesForm' }"
          >สร้าง Memo</router-link
        >
      </div>
    </div>

    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y box p-5 mt-5">
      <div class="flex flex-col gap-4">
        <form
          id="tabulator-html-filter-form"
          @submit.prevent="onFilter"
          class="flex flex-col sm:flex-row gap-4 items-start"
        >
          <div class="sm:flex items-center w-full sm:w-96">
            <TailSelect
              id="company-selected"
              v-model="filter.companySelected"
              placeholder="-- เลือกบริษัท --"
              :options="{
                hideSelected: true,
                hideDisabled: true,
                multiContainer: true,
                classNames: 'w-full'
              }"
              multiple
            >
              <option
                v-for="com in companyOption"
                :key="com.value"
                :value="com.value"
                >{{ com.label }}</option
              >
            </TailSelect>
          </div>
          <div class="sm:flex items-center sm:mr-4">
            <select
              id="tabulator-html-filter-field"
              v-model="filter.field"
              class="form-select w-full sm:w-32 xxl:w-full mt-2 sm:mt-0 sm:w-auto"
            >
              <option
                v-for="opt in filterOption"
                :key="opt.value"
                :value="opt.value"
                >{{ opt.label }}</option
              >
            </select>
          </div>
          <div class="sm:flex items-center sm:mr-4 mt-2 xl:mt-0">
            <label
              class="w-12 flex-none xl:w-auto xl:flex-initial mr-2 hidden sm:block"
              >ค้นหา</label
            >
            <input
              id="tabulator-html-filter-value"
              v-model="filter.value"
              type="text"
              class="form-control sm:w-40 xxl:w-full mt-2 sm:mt-0"
              :placeholder="filterPlaceholder"
            />
          </div>
          <div class="mt-2 xl:mt-0 gap-2 sm:gap-0 flex flex-row">
            <button
              id="tabulator-html-filter-go"
              type="button"
              class="btn btn-primary w-full sm:w-16"
              @click="onFilter"
            >
              ค้นหา
            </button>
            <button
              id="tabulator-html-filter-reset"
              type="button"
              class="btn btn-secondary w-full sm:w-16 sm:mt-0 sm:ml-1"
              @click="onResetFilter"
            >
              ยกเลิก
            </button>
          </div>
        </form>
        <div class="mt-4 xl:mt-0">
          <button
            id="tabulator-html-filter-reset"
            type="button"
            class="btn active mt-2 sm:mt-0 sm:ml-1"
            @click="onStatusOption(status)"
            v-for="status in statusOption"
            :key="status.value"
            :class="[
              tableTab.value === status.value
                ? 'btn-primary-soft'
                : 'btn-secondary-soft'
            ]"
          >
            {{ status.label }}
            <div
              class="text-white w-6 h-6  ml-2 text-xs rounded-full flex items-center justify-center bg-theme-6"
              v-if="myDocWait > 0 && status.value == 'my_wait'"
            >
              <div>
                {{ myDocWait }}
              </div>
            </div>
            <div
              class="text-white w-6 h-6  ml-2 text-xs rounded-full flex items-center justify-center bg-theme-6"
              v-if="myDocEdit > 0 && status.value == 'draft'"
            >
              <div>
                {{ myDocEdit }}
              </div>
            </div>
          </button>
        </div>
      </div>
      <div class="overflow-x-auto scrollbar-hidden">
        <div
          id="tabulator"
          ref="tableRef"
          class="mt-5 table-report table-report--tabulator"
        ></div>
      </div>
    </div>
    <!-- END: HTML Table Data -->
  </div>
</template>

<script>
import { defineComponent, ref, reactive, onMounted, computed, watch } from 'vue'
// import feather from 'feather-icons'
import Tabulator from 'tabulator-tables'
// import { filterOption } from './index'
import { myHeaders } from '@/utils/api'
import { helper } from '@/utils/helper'
import store from '../../../store'
import router from '@/router'
import feather from 'feather-icons'
import alert from '@/helpers/alert'

export default defineComponent({
  setup() {
    const tableRef = ref()
    const tabulator = ref()
    const search = computed(() => store.state.memo.search)
    const currentUrl = ref(null)
    const filter = reactive({
      field:
        search.value.field ||
        store.getters['global/getResetFilterList']('memo'),
      type: 'like',
      value: search.value.value,
      companySelected: search.value.companySelected
    })
    const myDocWait = computed(() => store.state.memo.countMyDoc)
    const myDocEdit = computed(() => store.state.memo.countEdit)
    // const myDocWait = ref(2)
    const companyOption = computed(
      () => store.getters['global/getCompanyOptions']
    )

    const tableTab = computed(() => store.state.memo.tableTab)

    const initTabulator = async () => {
      tabulator.value = new Tabulator(tableRef.value, {
        ajaxURL: tableTab.value.url,
        ajaxLoader: true,
        ajaxFiltering: true,
        ajaxSorting: true,
        virtualDom: false,
        pagination: 'remote',
        placeholder: 'ไม่พบข้อมูลที่ต้องการ',
        paginationSize: 50,
        // paginationSizeSelector: [10, 20, 30, 40],
        ajaxConfig: {
          method: 'GET',
          headers: await myHeaders()
        },
        ajaxResponse: async (url, params, response) => {
          // console.log('res datatable: ', response.code)
          // router.push({ name: 'login' })
          if (response.code == 200) {
            return response.data
          } else if (response.code == 401) {
            router.push({ name: 'login' })
          } else {
            alert.error('ข้อมูลผิดพลาด')
            return false
          }
        },

        ajaxURLGenerator: (url, headers, params) => {
          // console.log('ajaxURLGenerator: ', params)
          if (params) {
            const urlNew = []
            if (filter.companySelected.length) {
              for (const i in filter.companySelected) {
                urlNew.push(`company[]=${filter.companySelected[i]}`)
              }
            }
            if (params.sorters.length > 0) {
              urlNew.push(`sortBy=${params.sorters[0].field}`)
              urlNew.push(`sortDesc=${params.sorters[0].dir == 'desc'}`)
            }
            if (params.page) {
              urlNew.push(`page=${params.page}`)
            }
            if (params.size > 0) {
              urlNew.push(`per_page=${params.size}`)
            }
            // if (params.filters.length > 0) {
            if (search.value.value != null) {
              urlNew.push(`filterBy=${params.filters[0].field}`)
              urlNew.push(`filter=${params.filters[0].value}`)
            }
            const q = url.indexOf('?') == -1 ? '?' : '&'
            currentUrl.value = urlNew.length
              ? `${url}${q}${urlNew.join('&')}`
              : url

            store.commit('memo/updateTableTab', {
              page: params.page,
              currentUrl: currentUrl.value
            })

            return currentUrl.value
          } else {
            return url
          }
        },
        columns: [
          {
            title: '',
            field: 'id',
            width: '5%',
            minWidth: 50,
            headerSort: false,
            formatter: cell => {
              if (cell.getData().status_code == 'draft') {
                const a = cash(`<div class="flex lg:justify-center items-center">
                  <a href="javascript:;" class="flex items-center mr-3 text-theme-11 btn btn-outline-warning btn-sm">
                    <i data-feather="check-square" class="w-4 h-4"></i>
                  </a>
                </div>`)
                cash(a).on('click', () => {
                  router.push({
                    name: 'memoMyActivitiesFormEdit',
                    params: { id: cell.getData().id }
                  })
                })
                return a[0]
              } else {
                const a = cash(`<div class="flex lg:justify-center items-center">
                  <a href="javascript:;" class="flex items-center mr-3 text-theme-10 btn btn-outline-primary btn-sm">
                    <i data-feather="file-text" class="w-4 h-4"></i>
                  </a>
                </div>`)
                cash(a).on('click', () => {
                  router.push({
                    name: 'memoMyActivitiesFormDetail',
                    params: { id: cell.getData().id }
                  })
                })
                return a[0]
              }
            }
          },
          {
            title: 'เลขที่เอกสาร',
            field: 'doc_no_full',
            width: '10%',
            minWidth: 135
          },
          {
            title: 'วันที่เอกสาร',
            field: 'doc_date',
            width: '8%',
            minWidth: 110
          },
          {
            title: 'เรื่อง',
            field: 'title',
            width: '35%',
            formatter: cell => {
              return `${cell.getData().title} ${
                cell.getData().flag_edit == 2
                  ? '<span class="text-theme-6">(ตีกลับ)</span>'
                  : ''
              }`
            }
          },
          {
            title: 'เรียน',
            field: 'to_array',
            width: '5%',
            minWidth: 100,
            headerSort: false,
            formatter: cell => {
              const imgTo = cell.getData().to_array.map(
                item => `<div class="intro-x w-10 h-10 image-fit">
                    <img alt="${item.name} - ${item.position}" class="rounded-full img-employee" src="${item.employee_image}" >
                    <div class="${item.approve_status_theme} border-theme-21  text-theme-14 rounded-full absolute w-4 h-4 bottom-0 right-0"></div>
                  </div>`
              )
              return `<div class="flex ">${imgTo}</div>`
            }
          },
          {
            title: 'ผ่าน',
            field: 'cc_array',
            width: '20%',
            minWidth: 200,
            headerSort: false,
            formatter: cell => {
              const imgTo = cell.getData().cc_array.map(item => {
                let status = 'bg-gray-400'
                if (item.approve_status == 'approve') {
                  status = 'bg-theme-9'
                } else if (item.approve_status == 'disapprove') {
                  status = 'bg-theme-6'
                }
                const html = `<div class="intro-x w-10 h-10 image-fit text-theme-9 ">
                      <img alt="${item.name} - ${item.position}" class="rounded-full img-employee" src="${item.employee_image}">
                    <div class="${status} border-theme-21  text-theme-14 rounded-full absolute w-4 h-4 bottom-0 right-0"></div>
                  </div>`
                return html
              })
              return `<div class="flex ">${imgTo}</div>`
            }
          },
          {
            title: 'ผู้เปิดเอกสาร',
            field: 'doc_owner.name',
            width: '15%',
            minWidth: 150
          }
          // {
          //   title: 'เสนอเพื่อ',
          //   field: 'objective_status',
          //   width: '15%',
          //   formatter: cell => {
          //     return cell.getData().objective_name
          //   }
          // },
          // {
          //   title: 'วันที่สร้าง',
          //   field: 'create_date_text',
          //   width: '15%'
          // },
        ],
        renderComplete() {
          feather.replace({
            'stroke-width': 1.5
          })
          cash('.img-employee').on('error', helper.imgError)
        }
      })
    }

    // Filter function
    const onFilter = () => {
      // console.log('tabulator: ', tabulator.value)
      // tabulator.value.setURL(
      //   process.env.VUE_APP_API_URL + '/memo/memo/getByMyDocWait'
      // )
      // tabulator.value.setData(process.env.VUE_APP_API_URL + '/memo/memo/all')
      store.commit('memo/setFilter', {
        companySelected: filter.companySelected,
        value: filter.value,
        field: filter.field
      })

      tabulator.value.setFilter(filter.field, filter.type, filter.value)
    }

    // On reset filter
    const onResetFilter = () => {
      filter.field = store.getters['global/getResetFilterList']('memo')
      filter.type = 'like'
      filter.value = ''
      filter.companySelected = []

      store.commit('memo/clearFilter', {
        field: filter.field
      })

      tabulator.value.setData(tableTab.value.currentUrl)

      tabulator.value.clearFilter()
      // tabulator.value.setData(
      //   process.env.VUE_APP_API_URL + '/memo/memo/getMyDocs?status_code=draft'
      // )
      // onFilter()
    }

    // const filterOption = ref([])
    onMounted(async () => {
      initTabulator()
      // store.dispatch('memo/loadFilterOption')
      store.dispatch('global/loadCompany')
      store.dispatch('memo/loadDocStatusOption')
      store.dispatch('memo/loadCountMyDoc', store.state.auth.info.employeeId)
      // filterOption.value = await api.get('/memo/memo/allOption').then(res => {
      //   return res.data
      // })
    })
    const filterOption = computed(
      () => store.state.global.optionFilterList.memo
    )
    const statusOption = computed(() => store.state.memo.docStatusOption)

    const filterPlaceholder = ref(
      store.getters['global/getPlaceholderDefaultFilterList']('memo')
    )
    watch(
      () => filter.field,
      newVal => {
        filterPlaceholder.value = store.getters[
          'global/getPlaceholderFilterList'
        ](newVal, 'memo')
      }
    )

    // const statusOptionSelected = computed(() => store.state.memo.tableTab.value)
    // const statusMenuName = computed(() => store.state.memo.tableTab.label)
    const onStatusOption = status => {
      tabulator.value.setData(status.url)
      store.dispatch('memo/setTableTab', {
        label: status.label,
        value: status.value,
        url: status.url
      })
      // setColumns(status.value)
    }

    // const onStatusOption = status => {
    //   const tableUrl = ref(null)
    //   if (
    //     status.value == 'draft' ||
    //     status.value == 'wait' ||
    //     status.value == 'cancel'
    //   ) {
    //     tableUrl.value =
    //       process.env.VUE_APP_API_URL +
    //       '/memo/memo/getMyDocs?status_code=' +
    //       status.value
    //   } else if (status.value == 'my_wait') {
    //     tableUrl.value =
    //       process.env.VUE_APP_API_URL + '/memo/memo/getByMyDocWait'
    //   } else if (status.value == 'approve') {
    //     tableUrl.value =
    //       process.env.VUE_APP_API_URL + '/memo/memo/getDocApproved'
    //   } else if (status.value == 'my_approve') {
    //     tableUrl.value =
    //       process.env.VUE_APP_API_URL +
    //       '/memo/memo/getMyDocForUse?back_month=3'
    //   } else {
    //     tableUrl.value =
    //       process.env.VUE_APP_API_URL +
    //       '/memo/memo/all?status_code=' +
    //       status.value
    //   }

    //   tabulator.value.setData(tableUrl.value)
    //   store.dispatch('memo/setTableTab', {
    //     label: status.label,
    //     value: status.value,
    //     url: tableUrl.value
    //   })
    // }

    const imgError = () => {
      console.log('img error')
    }

    return {
      // statusMenuName,
      tableRef,
      filter,
      onFilter,
      onResetFilter,
      filterOption,
      statusOption,
      onStatusOption,
      // statusOptionSelected,
      tableTab,
      myDocWait,
      myDocEdit,
      filterPlaceholder,
      imgError,
      companyOption
    }
  }
})
</script>
